export default "__VITE_ASSET__DiuPVfZt__"